import { AccountEmployeeResolver } from '@account/account-employee.resolver';
/* Common Modules */
import { AccountRouterModule } from '@account/account.routes';
/* Common Views */
import { MultiFactorAuthentication } from '@account/components';
import { Views } from '@account/views';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentFoldersSidebarComponent } from '@app/modules/documents-v2/standalone-components';
import { PlatformModule } from '@app/platform.module';
import { BenefitsModule } from '@benefits/benefits.module';
import { AppCommonModule } from '@common/common.module';
import { DocumentModule } from '@document/document.module';
import { EmployeesCommonModule } from '@employees/employees.common.module';
import { EmployeesResolver } from '@employees/employees.resolver';
import { EmployeeChangeRequestTemplatesService } from '@employees/services';
import { TableModule } from '@table/table.module';
import { EmployeeResolver as TimeOffEmployeeResolver } from '@time-off-v3/resolvers/employee.resolver';
import { TimeOffService } from '@time-off-v3/services';
import { DocumentsV2Module } from '../documents-v2/documents-v2.module';
import { AccountFormsModule } from '../forms/account/account-forms.module';
import { BenefitsFormsModule } from '../forms/benefits/benefits-forms.module';
import { DocumentsFormsModule } from '../forms/documents/documents-forms.module';
import { EmployeeFormsModule } from '../forms/employees/employee-forms.module';
import { PerformanceFormsModule } from '../forms/performance/performance-forms.module';
import { KYCKYBStatus } from '../payroll/components/kyc-kyb/kyc-kyb-status/kyc-kyb-status.component';
import { MenuServices } from './services/menus';
import { Tables } from './services/tables';

@NgModule({
    imports: [
        AccountRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        EmployeesCommonModule,
        PlatformModule,
        TableModule,
        AccountFormsModule,
        BenefitsFormsModule,
        DocumentsFormsModule,
        DocumentModule,
        DocumentsV2Module,
        EmployeeFormsModule,
        PerformanceFormsModule,
        BenefitsModule,
        MultiFactorAuthentication,
        DocumentFoldersSidebarComponent,
        KYCKYBStatus,
    ],
    declarations: [...Views],
    providers: [
        AccountEmployeeResolver,
        EmployeesResolver,
        TimeOffEmployeeResolver,
        TimeOffService,
        EmployeeChangeRequestTemplatesService,
        ...Tables,
        ...MenuServices,
    ],
})
export class AccountModule {}
